var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Billing Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 1.59375V15.4062C21 15.8313 20.8425 16.2031 20.5275 16.5219C20.2125 16.8406 19.845 17 19.425 17H1.575C1.155 17 0.7875 16.8406 0.4725 16.5219C0.1575 16.2031 0 15.8313 0 15.4062V1.59375C0 1.16875 0.1575 0.796875 0.4725 0.478125C0.7875 0.159375 1.155 0 1.575 0H19.425C19.845 0 20.2125 0.159375 20.5275 0.478125C20.8425 0.796875 21 1.16875 21 1.59375ZM1.575 4.48906H19.425V1.59375H1.575V4.48906ZM1.575 7.91563V15.4062H19.425V7.91563H1.575Z",
    fill: "#FF7300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3913 11.6316C6.3913 12.6199 5.57374 13.4211 4.56522 13.4211C3.5567 13.4211 2.73913 12.6199 2.73913 11.6316C2.73913 10.6433 3.5567 9.8421 4.56522 9.8421C5.57374 9.8421 6.3913 10.6433 6.3913 11.6316Z",
    fill: "#FF7300"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.a96f30be24c121da9544f571d2a0c691.svg";
export { ForwardRef as ReactComponent };